import { createContext } from 'react';

import type { UseCustomerAccount } from '@/account/app/hooks/useCustomerAccount';

export const CustomerAccountContext = createContext<
  UseCustomerAccount | undefined
>(undefined);
